import { NSARouterMakerResult, TabRenderItem } from "namirasoft-account-react";
import { JournalEntryMode } from "namirasoft-erp";
import { Component } from "react";
import { JournalEntryLinesViewLoader } from "../components/JournalEntryLinesViewLoader";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class JournalEntryListPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout
                {...this.props}
                mode={ErpScopeMode.Filter}
                fields={[ErpScopeField.Company, ErpScopeField.Branch, ErpScopeField.FiscalYear]}
                pages={{
                    entity: ErpEntities.journal_entry(this.props),
                    list: {
                        ui: {
                            getRowAttributes: (row) =>
                            {
                                if (row.mode === JournalEntryMode.RequestToAdd)
                                    return { title: "Pending request to add", style: { backgroundColor: "#e3f2fd" } };
                                if (row.mode === JournalEntryMode.RequestToEdit)
                                    return { title: "Pending request to edit", style: { backgroundColor: "#fff3e0" } };
                                if (row.mode === JournalEntryMode.RequestToDelete)
                                    return { title: "Pending request to delete", style: { backgroundColor: "#ffebee" } };
                                if (row.finalized)
                                    return { style: { backgroundColor: "#d4f7d4" } };
                                return {};
                            },
                            tab_page_view: {
                                tabs: {
                                    general: {
                                        buildItems: (row, tab, columns) =>
                                        {
                                            let items: TabRenderItem[] = columns.map((column) => ({ type: "column", column }));
                                            if (tab === "General" && row.id)
                                                items.push({
                                                    type: "custom",
                                                    node: (
                                                        <div style={{ flexBasis: "100%", width: "100%" }}>
                                                            <JournalEntryLinesViewLoader {...this.props} journal_entry_id={row.id} />
                                                        </div>
                                                    ),
                                                });
                                            return items;
                                        },
                                    },
                                },
                            },
                            getChildrenAfter: (id, _row) =>
                            {
                                return <div style={{ flexBasis: "100%", width: "100%" }}>
                                    <JournalEntryLinesViewLoader {...this.props} journal_entry_id={id} />
                                </div>
                            },
                        },
                    },
                }}
            ><></></ErpLayout>
        );
    }
}